import { getSassmallResponseMessage, isSassmallResponseSuccess, sassmallRequest } from "./client";

export interface InternationalizationPreference {
  notificationLanguage: string | null;
  currencyPreference: string | null;
}

export async function getInternationalizationPreference() {
  const response = await sassmallRequest<InternationalizationPreference>("/customer/profile/internationalization");
  if (!isSassmallResponseSuccess(response) || !response.data) {
    throw new Error(getSassmallResponseMessage(response, "账号语言和币种加载失败"));
  }
  return response.data;
}

export async function updateInternationalizationPreference(preference: Partial<InternationalizationPreference>) {
  const response = await sassmallRequest<InternationalizationPreference>("/customer/profile/internationalization", {
    method: "POST", body: preference,
  });
  if (!isSassmallResponseSuccess(response) || !response.data) {
    throw new Error(getSassmallResponseMessage(response, "账号语言和币种修改失败"));
  }
  return response.data;
}

export async function getDestinationCountryRecommendation(countryCode: string) {
  const response = await sassmallRequest<{
    matched: boolean; defaultLanguage?: string; defaultCurrencyCode?: string;
  }>("/customer/destination-country-configs/recommendation", {
    query: { countryCode }, skipAuth: true, timeout: 5000,
  });
  if (!isSassmallResponseSuccess(response)) {
    throw new Error(getSassmallResponseMessage(response, "目的国推荐配置获取失败"));
  }
  return response.data || null;
}
